var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaystore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 88,
    viewBox: "0 0 227 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.762207,
    width: 225.762,
    height: 87.5238,
    rx: 43.7619,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.1627 31.3644C94.1627 32.421 93.7665 33.3454 93.2383 34.0057C92.4459 34.7981 91.5214 35.1943 90.3328 35.1943C89.1442 35.1943 88.2198 34.7981 87.4274 34.0057C86.635 33.2134 86.2388 32.2889 86.2388 31.1003C86.2388 29.9117 86.635 28.9872 87.4274 28.1949C88.2198 27.4025 89.1442 27.0063 90.3328 27.0063C90.8611 27.0063 91.3893 27.1383 91.9176 27.4025C92.4459 27.6666 92.8421 27.9307 93.1062 28.3269L92.4459 28.9872C91.9176 28.3269 91.2573 28.0628 90.2007 28.0628C89.4083 28.0628 88.616 28.3269 88.0877 28.9872C87.4274 29.5155 87.1632 30.3079 87.1632 31.2324C87.1632 32.1568 87.4274 32.9492 88.0877 33.4775C88.748 34.0057 89.4083 34.4019 90.2007 34.4019C91.1252 34.4019 91.7855 34.1378 92.4459 33.4775C92.8421 33.0813 93.1062 32.553 93.1062 31.8927H90.2007V30.9682H94.0306C94.1627 30.9682 94.1627 31.2324 94.1627 31.3644Z",
    fill: "#2F2F2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.369 28.062H96.8036V30.5713H100.105V31.4957H96.8036V34.005H100.369V34.9294H95.7471V27.1376H100.369V28.062Z",
    fill: "#2F2F2F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.595 34.9294H103.539V28.062H101.426V27.1376H106.84V28.062H104.595V34.9294Z",
    fill: "#2F2F2F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M110.809 34.9294V27.1376H111.865V34.9294H110.809Z",
    fill: "#2F2F2F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M116.353 34.9294H115.297V28.062H113.052V27.1376H118.598V28.062H116.353V34.9294Z",
    fill: "#2F2F2F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M128.901 34.0057C128.109 34.7981 127.184 35.1943 125.996 35.1943C124.807 35.1943 123.883 34.7981 123.09 34.0057C122.298 33.2134 121.902 32.2889 121.902 31.1003C121.902 29.9117 122.298 28.9872 123.09 28.1949C123.883 27.4025 124.807 27.0063 125.996 27.0063C127.184 27.0063 128.109 27.4025 128.901 28.1949C129.694 28.9872 130.09 29.9117 130.09 31.1003C130.09 32.1568 129.694 33.2134 128.901 34.0057ZM123.751 33.3454C124.279 33.8737 125.071 34.2699 125.864 34.2699C126.656 34.2699 127.449 34.0057 127.977 33.3454C128.505 32.8172 128.901 32.0248 128.901 31.1003C128.901 30.1758 128.637 29.3834 127.977 28.8552C127.449 28.3269 126.656 27.9307 125.864 27.9307C125.071 27.9307 124.279 28.1949 123.751 28.8552C123.223 29.3834 122.826 30.1758 122.826 31.1003C122.958 32.0248 123.223 32.6851 123.751 33.3454Z",
    fill: "#2F2F2F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M131.54 34.9294V27.1376H132.728L136.558 33.2126V31.7599V27.1376H137.615V34.9294H136.558L132.464 28.5903V30.043V34.9294H131.54Z",
    fill: "#2F2F2F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M121.9 46.42C118.731 46.42 116.222 48.7971 116.222 51.9667C116.222 55.1363 118.731 57.5135 121.9 57.5135C125.07 57.5135 127.579 55.1363 127.579 51.9667C127.579 48.7971 125.07 46.42 121.9 46.42ZM121.9 55.4004C120.184 55.4004 118.731 53.9477 118.731 51.9667C118.731 49.9857 120.184 48.533 121.9 48.533C123.617 48.533 125.07 49.8537 125.07 51.9667C125.07 53.9477 123.617 55.4004 121.9 55.4004ZM109.618 46.42C106.449 46.42 103.939 48.7971 103.939 51.9667C103.939 55.1363 106.449 57.5135 109.618 57.5135C112.788 57.5135 115.297 55.1363 115.297 51.9667C115.165 48.7971 112.656 46.42 109.618 46.42ZM109.618 55.4004C107.901 55.4004 106.449 53.9477 106.449 51.9667C106.449 49.9857 107.901 48.533 109.618 48.533C111.335 48.533 112.788 49.8537 112.788 51.9667C112.788 53.9477 111.335 55.4004 109.618 55.4004ZM94.959 48.1368V50.514H100.638C100.506 51.8347 99.9775 52.7591 99.3172 53.4195C98.5248 54.2119 97.2041 55.1363 94.959 55.1363C91.3932 55.1363 88.7519 52.3629 88.7519 48.7972C88.7519 45.2314 91.5253 42.458 94.959 42.458C96.8079 42.458 98.2607 43.2504 99.3172 44.1749L101.034 42.458C99.5813 41.1373 97.7324 40.0808 95.0911 40.0808C90.2046 40.0808 86.2427 43.9107 86.2427 48.6651C86.2427 53.4194 90.3367 57.2494 95.0911 57.2494C97.7324 57.2494 99.7134 56.457 101.166 54.8722C102.751 53.2874 103.279 51.1743 103.279 49.3254C103.279 48.7971 103.279 48.2689 103.147 47.8727C102.883 48.1368 94.959 48.1368 94.959 48.1368ZM154.917 49.9857C154.389 48.7971 153.068 46.42 150.03 46.42C147.125 46.42 144.748 48.6651 144.748 51.9667C144.748 55.1363 147.125 57.5135 150.295 57.5135C152.936 57.5135 154.389 55.9287 155.049 55.0042L153.068 53.6836C152.408 54.608 151.615 55.2684 150.295 55.2684C149.106 55.2684 148.181 54.7401 147.521 53.5515L155.049 50.514C155.181 50.6461 154.917 49.9857 154.917 49.9857ZM147.257 51.8347C147.257 49.7216 148.974 48.533 150.162 48.533C151.087 48.533 152.011 49.0613 152.276 49.7216L147.257 51.8347ZM141.05 57.2494H143.559V40.8732H141.05V57.2494ZM137.088 47.6086C136.428 46.9482 135.371 46.42 134.05 46.42C131.277 46.42 128.636 48.9292 128.636 51.9667C128.636 55.1363 131.277 57.5135 134.05 57.5135C135.371 57.5135 136.428 56.9852 136.956 56.1928H137.088V56.9852C137.088 59.0983 135.899 60.2869 134.05 60.2869C132.598 60.2869 131.541 59.2303 131.277 58.3059L129.164 59.2303C129.824 60.6831 131.409 62.532 134.183 62.532C137.088 62.532 139.597 60.8151 139.597 56.7211V46.6841H137.22L137.088 47.6086ZM134.183 55.4004C132.466 55.4004 131.013 53.9477 131.013 52.0988C131.013 50.1178 132.466 48.6651 134.183 48.6651C135.899 48.6651 137.22 50.1178 137.22 52.0988C137.22 53.9477 135.899 55.4004 134.183 55.4004ZM166.407 40.8732H160.464V57.2494H162.973V51.0423H166.407C169.18 51.0423 171.821 49.0613 171.821 46.0238C171.953 42.8542 169.18 40.8732 166.407 40.8732ZM166.539 48.7972H162.973V43.1183H166.539C168.388 43.1183 169.444 44.571 169.444 45.8917C169.444 47.2124 168.388 48.7972 166.539 48.7972ZM181.858 46.42C180.009 46.42 178.16 47.2124 177.5 48.9292L179.745 49.8537C180.273 48.9292 181.066 48.6651 181.99 48.6651C183.311 48.6651 184.632 49.4575 184.632 50.7781V50.9102C184.235 50.6461 183.179 50.2499 181.99 50.2499C179.613 50.2499 177.236 51.5705 177.236 53.9477C177.236 56.1928 179.217 57.5135 181.33 57.5135C183.047 57.5135 183.971 56.7211 184.5 55.9287H184.632V57.2494H187.009V50.9102C186.877 48.0048 184.632 46.42 181.858 46.42ZM181.462 55.4004C180.67 55.4004 179.481 55.0042 179.481 54.0798C179.481 52.7591 180.934 52.3629 182.122 52.3629C183.179 52.3629 183.707 52.6271 184.368 52.8912C184.235 54.3439 182.915 55.4004 181.462 55.4004ZM195.461 46.8162L192.688 53.9477H192.556L189.65 46.8162H187.009L191.367 56.7211L188.858 62.2679H191.499L198.234 46.8162H195.461ZM173.274 57.2494H175.783V40.8732H173.274V57.2494Z",
    fill: "#2F2F2F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4842 28.1306C45.0907 28.5241 44.8284 29.18 44.8284 29.9671V58.6945C44.8284 59.4815 45.0907 60.1374 45.4842 60.5309L45.6154 60.6621L61.8812 44.5275V44.134L45.4842 28.1306Z",
    fill: "url(#paint0_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2593 49.9055L61.8811 44.5273V44.1338L67.2593 38.7556L67.3905 38.8868L73.8181 42.5597C75.6545 43.6091 75.6545 45.3144 73.8181 46.3638L67.2593 49.9055C67.3905 49.9055 67.2593 49.9055 67.2593 49.9055Z",
    fill: "url(#paint1_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3907 49.9049L61.8813 44.3955L45.4844 60.5301C46.1403 61.1859 47.0585 61.1859 48.2391 60.6612L67.3907 49.9049Z",
    fill: "url(#paint2_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3907 38.8868L48.2391 28.1304C47.0585 27.4745 46.1403 27.6057 45.4844 28.2616L61.8813 44.3962L67.3907 38.8868Z",
    fill: "url(#paint3_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 60.4124,
    y1: 58.9843,
    x2: 38.6043,
    y2: 36.9185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 76.1997,
    y1: 44.3305,
    x2: 44.3832,
    y2: 44.3305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 53.4044,
    y1: 52.1876,
    x2: 23.8308,
    y2: 22.2647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 30.4041,
    y1: 59.3355,
    x2: 43.6101,
    y2: 45.9737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/playstore.074cb14357a3f76f58b1c9f9baec0ff1.svg";
export { ForwardRef as ReactComponent };